import React, { useEffect, useState } from "react";
import plans from "./data/data";
import { useSelector } from "react-redux";
import { GetExchangeRate } from "../../../../apis";
import accounting from "accounting";
import handleSubmitPlan from "./apis/handleSubmitPlan";

const PlanCards = () => {
  const user = useSelector((state) => state.user.user);
  const activePlan = user?.plan?.type || "Free";
  const isFreePlan = activePlan?.toLowerCase() === "free";

  const [rates, setRates] = useState(1);
  const [currency, setCurrency] = useState("USD"); // "USD" or "INR"

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedPlan, setselectedPlan] = useState(null);
  const [duration, setDuration] = useState("1");

  console.log("selectedPlan", selectedPlan);

  useEffect(() => {
    const getRate = async () => {
      const usd = parseFloat(localStorage.getItem("USD"));
      const inr = parseFloat(localStorage.getItem("INR"));

      if (usd > 0 && inr > 0) {
        setRates(currency === "INR" ? inr : usd);
        return;
      }

      const rate = await GetExchangeRate();
      if (rate) {
        localStorage.setItem("USD", rate.USD);
        localStorage.setItem("INR", rate.INR);
        setRates(currency === "INR" ? rate.INR : rate.USD);
      }
    };

    getRate();
  }, [currency]);

  const handleChoose = (plan) => {
    setselectedPlan(plan);
    setDuration("1");
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setselectedPlan(null);
  };

  const handleConfirm = async (event) => {
    if (!selectedPlan) return;

    await handleSubmitPlan(
      event,
      selectedPlan?.name,
      user?.userId,
      user?.email,
      duration,
      currency
    );
    closeModal();
  };

  const formattedDate = (date) =>
    new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });

  const calculateExpiry = (startDate, months) => {
    const expiryDate = new Date(startDate);
    expiryDate.setMonth(expiryDate.getMonth() + months);
    return expiryDate;
  };

  const getLaunchPrice = () => {
    const offer = selectedPlan?.priceoffer?.[duration];
    if (!offer) return 0;
    const price =
      currency === "INR" ? offer.launchOffer * rates : offer.launchOffer;
    return price;
  };

  return (
    <>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 p-4">
        {plans.map((plan) => {
          const isCurrentPlan =
            activePlan?.toLowerCase() === plan?.name.toLowerCase();
          const isFreeAndActive =
            isCurrentPlan && plan?.name.toLowerCase() === "free";
          const isUpgradable =
            !isFreePlan && plan?.name.toLowerCase() !== "free";

          return (
            <div
              key={plan?.name}
              className={`flex flex-col justify-between rounded-xl border p-6 transition-all bg-white ${
                isUpgradable ? "ring-2 ring-green-400 hover:shadow-lg" : ""
              } ${
                isFreeAndActive
                  ? "opacity-60 cursor-not-allowed"
                  : "hover:shadow-md"
              }`}>
              <div>
                <h3 className="text-xl font-semibold text-primary mb-2">
                  {plan?.name}
                </h3>
                <ul className="text-sm text-gray-700 space-y-2 mb-4">
                  <li>
                    💬{" "}
                    <strong>{plan?.monthly_messages.toLocaleString()}</strong>{" "}
                    Monthly Messages
                  </li>
                  <li>
                    🔗 <strong>{plan?.links_to_crawl.toLocaleString()}</strong>{" "}
                    Links to Crawl
                  </li>
                  <li>
                    🤖 <strong>{plan?.max_chatbots}</strong> Chatbots
                  </li>
                </ul>

                {typeof plan?.priceoffer === "string" ? (
                  <p className="text-green-600 font-semibold text-lg">
                    ${plan?.price}/month
                  </p>
                ) : (
                  <div className="text-sm space-y-1">
                    {Object.entries(plan?.priceoffer).map(([key, offer]) => (
                      <div
                        key={key}
                        className={`p-2 rounded-md ${
                          offer.bestOffer
                            ? "bg-yellow-100 border border-yellow-400"
                            : "bg-gray-100"
                        }`}>
                        <span className="font-medium">
                          {key} month{parseInt(key) > 1 ? "s" : ""}
                        </span>
                        :
                        <span className="text-green-600 font-bold ml-2">
                          ${accounting.formatNumber(offer.launchOffer)}
                        </span>
                        <span className="line-through text-gray-400 ml-2">
                          ${accounting.formatNumber(offer.regular)}
                        </span>
                        {offer.bestOffer && (
                          <span className="ml-2 text-xs text-yellow-600 font-bold">
                            ⭐ Best Offer
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <button
                disabled={isFreeAndActive}
                onClick={() => handleChoose(plan)}
                className={`mt-6 w-full font-medium py-2 rounded-lg transition ${
                  isFreeAndActive
                    ? "bg-gray-300 text-gray-700 cursor-not-allowed"
                    : "bg-primary text-white hover:bg-darkprimary"
                }`}>
                {isCurrentPlan ? "Current Plan" : `Choose ${plan?.name}`}
              </button>
            </div>
          );
        })}
      </div>

      {/* Modal */}
      {isModalOpen && selectedPlan && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-md mx-4">
            <h2 className="text-lg font-semibold text-primary mb-4">
              Subscribe to {selectedPlan?.name} Plan
            </h2>

            <div className="mb-4 p-3 bg-gray-50 border rounded-md">
              <h3 className="text-sm font-semibold mb-2 text-gray-800">
                Plan Benefits:
              </h3>
              <ul className="list-disc list-inside text-sm text-gray-700">
                {selectedPlan && (
                  <>
                    <li>
                      💬 <strong>{selectedPlan?.name}</strong> Plan
                    </li>
                    <li>
                      💬{" "}
                      <strong>
                        {(
                          selectedPlan?.monthly_messages * parseInt(duration)
                        )?.toLocaleString()}
                      </strong>{" "}
                      Monthly Messages
                    </li>
                    <li>
                      🔗{" "}
                      <strong>
                        {selectedPlan?.links_to_crawl?.toLocaleString()}
                      </strong>{" "}
                      Links to Crawl
                    </li>
                    <li>
                      🤖 <strong>{selectedPlan?.max_chatbots}</strong> Chatbots
                    </li>
                  </>
                )}
              </ul>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium mb-1">
                Choose Duration
              </label>
              <select
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                className="w-full border p-2 rounded-md">
                {Object.keys(selectedPlan?.priceoffer).map((d) => (
                  <option key={d} value={d}>
                    {d} Month{parseInt(d) > 1 ? "s" : ""}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-4 flex items-center justify-between">
              <p className="text-sm text-gray-700">
                You’ll pay{" "}
                <span className="font-bold text-primary">
                  {accounting.formatMoney(
                    getLaunchPrice(),
                    currency === "INR" ? "₹" : "$"
                  )}
                </span>{" "}
                for{" "}
                <strong>
                  {duration} month{parseInt(duration) > 1 ? "s" : ""}
                </strong>
                .
              </p>

              <select
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
                className="text-xs border p-1 rounded-md text-gray-700 bg-white">
                <option value="USD">USD $</option>
                <option value="INR">INR ₹</option>
              </select>
            </div>

            <div className="mb-4 text-sm text-gray-700">
              {selectedPlan?.type?.toLowerCase() !== "free" ? (
                <>
                  <p>
                    <strong>Start:</strong>{" "}
                    {formattedDate(new Date(user?.plan?.expiredAt))}
                  </p>
                  <p>
                    <strong>Expires:</strong>{" "}
                    {formattedDate(
                      calculateExpiry(
                        new Date(user?.plan?.expiredAt),
                        parseInt(duration)
                      )
                    )}
                  </p>
                </>
              ) : (
                <>
                  <p>
                    <strong>Start:</strong> {formattedDate(new Date())}
                  </p>
                  <p>
                    <strong>Expires:</strong>{" "}
                    {formattedDate(
                      calculateExpiry(new Date(), parseInt(duration))
                    )}
                  </p>
                </>
              )}
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-gray-200 rounded-md text-gray-700 hover:bg-gray-300">
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                className="px-4 py-2 bg-primary text-white rounded-md hover:bg-darkprimary">
                Confirm & Pay
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PlanCards;
